import React from "react"
import { Link } from "react-router-dom"

const Logo = ({ imgSrc }) => (
  <Link to="/">
    <img src={imgSrc} alt="MM Baza logo" />
  </Link>
)

export default Logo
